module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_4.1dc870ec.mp3";